var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareUserSvgrepo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 22C6.5625 18.7209 9.22082 16.0625 12.5 16.0625C15.7791 16.0625 18.4375 18.7209 18.4375 22M6.8 22H18.2C19.5302 22 20.1953 22 20.7032 21.7411C21.1501 21.5136 21.5134 21.1501 21.7411 20.7032C22 20.1953 22 19.5302 22 18.2V6.80001C22 5.46989 22 4.80482 21.7411 4.29678C21.5134 3.84988 21.1501 3.48656 20.7032 3.25887C20.1953 3 19.5302 3 18.2 3H6.8C5.46988 3 4.8048 3 4.29677 3.25887C3.84988 3.48656 3.48655 3.84988 3.25886 4.29678C3 4.80482 3 5.46988 3 6.80001V18.2C3 19.5302 3 20.1953 3.25886 20.7032C3.48655 21.1501 3.84988 21.5136 4.29677 21.7411C4.8048 22 5.46987 22 6.8 22ZM14.875 10.1251C14.875 11.4367 13.8117 12.5 12.5 12.5C11.1883 12.5 10.125 11.4367 10.125 10.1251C10.125 8.81334 11.1883 7.75001 12.5 7.75001C13.8117 7.75001 14.875 8.81334 14.875 10.1251Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareUserSvgrepo);
export default __webpack_public_path__ + "static/media/square-user-svgrepo.a6c76818121e641fb4bd35fb92798ce3.svg";
export { ForwardRef as ReactComponent };